import { useState } from 'react'
import { useAuth } from 'ict24h-themes-react'
import { getCurrentUser as getService } from '../user.service'
import { UserEntity } from '../../../../../server-api-hrm.type'
import commonRequestHandler from '../../../../../utils/common-request-handler'
import requestErrorHandler from '../../../../../utils/request-error-handler'

type RequestFailType = 'SERVER' | 'RESOURCE' | 'OTHER'

type Params = {
  onGetDetailFail?: (_failType: RequestFailType) => void
  onFinish?: (_res: UserEntity) => void
  customRequestHandler?: boolean
}

const useGetCurrentUser = (params: Params = {}) => {
  const { token } = useAuth()

  const [loading, setLoading] = useState(false)
  const [currentUser, setCurrentUser] = useState<UserEntity>()

  const getCurrentUser = async (localHandler: Params = {}) => {
    const onFail = localHandler.onGetDetailFail || params.onGetDetailFail
    const onFinish = localHandler.onFinish || params.onFinish
    const customRequestHandler =
      localHandler?.customRequestHandler || params.customRequestHandler

    const requestHandler = customRequestHandler
      ? requestErrorHandler
      : commonRequestHandler

    setLoading(true)
    const res = await getService(token)
    setLoading(false)

    if (!res || !res.data) {
      if (typeof onFail === 'function') onFail('OTHER')
      return
    }

    requestHandler({
      status: res?.status,
      onSuccess: () => {
        setCurrentUser(res.data)
        if (typeof onFinish === 'function') onFinish(res.data)
      },
      onResourceFail: () => {
        if (typeof onFail === 'function') onFail('RESOURCE')
      },
      onServerFail: () => {
        if (typeof onFail === 'function') onFail('SERVER')
      },
    })
  }

  return {
    loading,
    currentUser,
    getCurrentUser,
  }
}

export default useGetCurrentUser
